module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Right 3-63a43cd982995d320838573a916d94a4.svg";